// extracted by css-extract-rspack-plugin
export default {"wrapper":"_469e91ef","buttonWrapper":"_e14a7ff9"};